import { Component } from '@angular/core';
import { Theme, ThemeService } from '../../theme/theme.service';

@Component({
  selector: 'ss-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
  standalone: false
})
export class ThemeToggleComponent {
  readonly options: { theme: Theme; icon: string; label: string }[] = [
    { theme: 'light', icon: 'sun', label: 'Tema claro' },
    { theme: 'dark', icon: 'moon', label: 'Tema escuro' }
  ];

  constructor(public themeService: ThemeService) { }

  select(theme: Theme) {
    this.themeService.setTheme(theme);
  }

  onKeydown(event: KeyboardEvent) {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
      return;
    }

    event.preventDefault();
    const next: Theme = this.themeService.theme === 'light' ? 'dark' : 'light';
    this.select(next);
    const buttons = (event.currentTarget as HTMLElement).querySelectorAll<HTMLButtonElement>('button');
    buttons[next === 'light' ? 0 : 1]?.focus();
  }
}
